import swal from "sweetalert";
import UIfx from "uifx";
import * as $ from "jquery";
import { type } from "jquery";
const queryString = require("query-string");

let {defaultTheme, appRoute} = window["app-config"].applicationProperties;
let defaultLang = window["app-config"].defaultLang;
let theme = queryString.parse(window.location.search).theme;

export const validation = {
  isEmailAddress: function (str) {
    var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return pattern.test(str); // returns a boolean
  },
  isNotEmpty: function (str) {
    var pattern = /\S+/;
    return pattern.test(str); // returns a boolean
  },
  isNumber: function (str) {
    var pattern = /^\d+$/;
    return pattern.test(str); // returns a boolean
  },
  isSame: function (str1, str2) {
    return str1 === str2;
  },
};

export const setTranslations = () => {
  const urlLang = queryString.parse(window.location.search).lang;
  let defaultLanguage = window["app-config"].defaultLang;
  let languages = window["localization"];
  var langs = Object.keys(languages);
  var setLanguage = {};

  for (let i = 0; i < langs.length; i++) {
    if (urlLang === undefined) {
      setLanguage = languages[defaultLanguage];
      break;
    }
    if (urlLang !== "" && langs[i] === urlLang) {
      let key = langs[i];
      setLanguage = languages[key];
      break;
    }
  }
  return setLanguage;
};

export const blinkText = (selector) => {
  setInterval(function () {
    $(selector).fadeToggle();
  }, 750);
};

export const disableCopyPasteInTextField = (selector) => {
  $(selector).bind("cut copy paste", function (e) {
    e.preventDefault();
  });
};

export const customTimeOut = () => {
  var isStopped = true;
  setTimeout(() => {
    isStopped = false;
  }, 3000);

  return isStopped;
};

export const openBrowserWindow = (url) => {
  window.open(
    `/${url}`,
    "myWindow",
    `status=1,toolbar=0, width=${window.screen.width}, height=${window.screen.height}`
  );
};

export const urls = {
  MODIFY_APPOINTMENT: `${
    window.location.origin
  }/modifyappointment?appointmentnumber={{appointment_number}}&theme=${
    theme == undefined ? defaultTheme : theme
  }&lang=`,
  CHECK_IN: `${window.location.origin}/modifyappointment`,
};

export const removeKeyFromUrl = (path, key, otherQueryString) => {
  let urlObject = queryString.parse(window.location.search);
  if (urlObject.appointmentnumber !== undefined) {
    delete urlObject[key];
  }
  let url = `${window.location.origin}/${path}?theme=${
    urlObject.theme === undefined ? defaultTheme : urlObject.theme
  }&lang=${urlObject.lang === undefined ? defaultLang : urlObject.lang}${
    otherQueryString !== undefined ? otherQueryString : ""
  }`;
  return url;
};

export const setPhoneNumberPrefix = () => {
  const language = queryString.parse(window.location.search).lang;
  let phoneNumberPrefix = window["app-config"].phoneNumberPrefix;
  if (localStorage.getItem("lang") === "es" && phoneNumberPrefix.spain !== "") {
    return phoneNumberPrefix.spain;
  } else if (
    localStorage.getItem("lang") === "ar" &&
    phoneNumberPrefix.uae !== ""
  ) {
    return phoneNumberPrefix.uae;
  } else if (
    localStorage.getItem("lang") === "en" &&
    phoneNumberPrefix.uk !== ""
  ) {
    return phoneNumberPrefix.uk;
  } else if (
    localStorage.getItem("lang") === "ur" &&
    phoneNumberPrefix.pakistan !== ""
  ) {
    return phoneNumberPrefix.pakistan;
  } else {
    this.setState({ phoneNumber: phoneNumberPrefix.defaultPhoneNumber });
  }
};

export const compareArrayOfObject = (firstArray, secondArray) => {
  return firstArray.filter((firstArrayItem) =>
    secondArray.some(
      (secondArrayItem) =>
        firstArrayItem.CategoryID === secondArrayItem.categoryId
    )
  );
};

export const redirect = (url) => {
  window.location.href = url;
};

export const showErrorMessage = async (title, message, okBtnText) => {
  let resp = await swal(title, message, "error", {
    buttons: {
      ok: {
        text: okBtnText,
        value: "ok",
      },
    },
  });
  if (resp === "ok") {
    redirect(window.location.href);
  }
};

export const showErrMsg = async (title, message, okBtnText, url) => {
  let resp = await swal(title, message, "error", {
    buttons: {
      ok: {
        text: okBtnText,
        value: "ok",
      },
    },
  });
  if (resp === "ok") {
    redirect(url);
  }
};

export const showSuccessMessage = async (message, okBtnText, redirectUrl) => {
  let resp = await swal("", message, "success", {
    buttons: {
      ok: {
        text: okBtnText,
        value: "ok",
      },
    },
    // closeOnClickOutside: false,
    // closeOnEsc: false,
  });
  if (resp === "ok") {
    window.location.href =redirectUrl;
  }
};

export const formatTimeStamp = (ts, type) => {
  let timestamp = parseInt(ts);

  let hours = Math.floor(timestamp / 60 / 60);

  let minutes = Math.floor(timestamp / 60) - hours * 60;
  let seconds = timestamp % 60;

  if (parseInt(hours) < 0 || parseInt(hours) === 0) {
    hours = "00";
  }
  if (parseInt(minutes) < 0 || parseInt(hours) === 0) {
    minutes = type === "minutes" ? "0" : "00";
  }
  if (parseInt(seconds) < 0 || parseInt(hours) === 0) {
    seconds = "00";
  }

  if (hours.toString().length === 1) {
    hours = `0${hours}`;
  }

  if (minutes.toString().length === 1) {
    minutes = type === "minutes" ? `${minutes}` : `0${minutes}`;
  }
  let formatted = type === "minutes" ? minutes : hours + ":" + minutes;
  return formatted;
};

export const notify = () => {
  let notificationSound = window["app-config"].notificationSound;
  let bell = new UIfx(process.env.PUBLIC_URL + `/sounds/${notificationSound}`, {
    volume: 0.8, // number between 0.0 ~ 1.0
    throttleMs: 100,
  });

  bell.play();
};

export const applicationMode = () => {
  let showConsole = window["app-config"].applicationProperties.showConsoleLogs;
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    console.log("DEVELOPMENT MODE");
  } else if (!process.env.NODE_ENV || process.env.NODE_ENV === "production") {
    if (!showConsole) {
      console.log = () => {};
    }
    document.onkeydown = (e) => {
      if (e.keyCode == 123) {
        return false;
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode == "I".charCodeAt(0)) {
        return false;
      }
      // if (e.ctrlKey && e.shiftKey && e.keyCode == "C".charCodeAt(0)) {
      //   return false;
      // }
      if (e.ctrlKey && e.shiftKey && e.keyCode == "J".charCodeAt(0)) {
        return false;
      }
      if (e.ctrlKey && e.keyCode == "U".charCodeAt(0)) {
        return false;
      }
    };

    document.addEventListener("contextmenu", function (e) {
      e.preventDefault();
    });
  }
};

export const validateEmail = (email) => {
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  return emailReg.test(email);
};

export const onBrowserReload = (callback) => {
  var type;
  if (window.performance.getEntriesByType("navigation")) {
    type = window.performance.getEntriesByType("navigation")[0].type;

    if (type == "navigate") {
      console.log("TYPE_NAVIGATE");
    }
    if (type == "reload") {
      callback();
    }
    if (type == "back_forward") {
      console.log("BACK_FORWARD");
    }
    if (type == "prerender") {
      console.log("PRE_RENDER");
    }
  }

  // const entries = performance.getEntriesByType("navigation");
  // console.log("ENTREIS: ", entries)
  // let type = entries.map((nav) => nav.type);
  // console.log("NAVIGATION TYPE: ", type[0]);

  // if (type[0] === "reload") {
  //   if (callback) {
  //     callback();
  //   }
  // }
};

export const windowReloadedOldMethod = (event) => {
  window.addEventListener("onbeforeunload", () => {
    console.log("HELLO");
  });

  if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
    console.info("This page is reloaded");
  } else {
    console.info("This page is not reloaded");
  }
};
